
const transformHotspotName = (name) => name.replace(/\s+/g, '-').replace(',', '').toLowerCase();

export const waitSomeTime = async (milliseconds) => {
    const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
    await wait(milliseconds);
}

export default transformHotspotName;
